export default __webpack_public_path__ + "static/media/Rest_Room.72e1f76e.svg";